export default __webpack_public_path__ + "static/indoor5-0940e56d7cb39dc1f2e3756d8d639f7b.webp";